import React, { useEffect, useState } from 'react';

import NaverLogin from 'react-naver-login';
import KakaoLogin from "react-kakao-login";

import { toast } from 'react-toastify';

import Button from './Button';

import * as APIS from "../utils/service";
import { randomNumberLength, errorMessage } from "../utils/utils.js";


import { usePopup, useUser } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";

import images from '../libs/images';
import consts from '../libs/consts';

export default function SnsLogin({
    type,
    onStart = () => { },
    onEnd = () => { }
}) {

    const { user, token, login } = useUser();
    const { closeSignPop } = usePopup();

    const naverLoginFunc = (user) => {
        console.log('naver', user);
        // let hp = "01006751190";
        let hp = "010" + randomNumberLength(8); // 지금은 랜덤 가입

        loginFunc({
            type: 'naver',
            id: user?.id,
            email: user?.email,
            name: user?.name,
            hp: hp
        });

    }
    const kakaoLoginFunc = (user) => {
        console.log('kakao', user);

        let hp = "010" + randomNumberLength(8); // 지금은 랜덤 가입
        let email = user?.profile?.id + "@kakao.com";
        loginFunc({
            type: 'kakao',
            id: user?.profile?.id,
            email: email,
            name: user?.profile?.kakao_account?.profile?.nickname,
            hp: hp
        });

    }

    const loginFunc = (sender) => {

        console.log('sender', sender);

        APIS.post('/login', sender).then(({ data }) => {
            console.log('data', data);

            login({ token: data });

            closeSignPop();

        }).catch(({ response }) => {

            // warning
            // warn
            console.log(response);

            onEnd();
            errorMessage(response?.data);
        });

    }

    const snsFailFunc = (err) => {
        console.log(err);

        onEnd();
        toast.error(<LangText id={'error_sns_login'} />);
    }

    return (
        type === 'kakao' ? (
            <Button type="_kakao" opacity={false} image={images.kakao} title={<LangText id={'btn_kakao_login'} />} onClick={(e) => {
                toast.info("This feature is coming soon.")
            }} />
            // <KakaoLogin
            //     token={'4f6b041bbcaf69d722d229c82ef385c4'}
            //     scopes={['profile_nickname','email']}
            //     onSuccess={kakaoLoginFunc}
            //     onFail={snsFailFunc}
            //     render={({ onClick }) => {
            //         return (
            //             <Button type="_kakao" opacity={false} image={images.kakao} title={<LangText id={'btn_kakao_login'}/>} onClick={(e) => { onClick(); onStart(); }} />
            //         )
            //     }}
            // /> 
        ) : type === 'naver' ? (
            <Button type="_naver" opacity={false} image={images.naver} title={<LangText id={'btn_naver_login'} />} onClick={() => {
                toast.info("This feature is coming soon.")
            }} />
            // <NaverLogin
            //     clientId="Lfaice2y1WSsn6snBRwq"
            //     callbackUrl="http://localhost:3000"
            //     render={({ onClick }) => <Button type="_naver" opacity={false} image={images.naver} title={<LangText id={'btn_naver_login'} />} onClick={() => { onClick(); onStart(); }} />}
            //     onSuccess={naverLoginFunc}
            //     onFailure={snsFailFunc}
            // />
        ) : (
            <></>
        )

    )
}